import { IChartContainer } from "../../models/base/chart-container.interface";
import { HeartStatusDataModel } from "../../models/heart-status/heart-status-data.model";
import { IComponent } from "../component.interface";

export class HeartStatusComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;
    private model = new HeartStatusDataModel();

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element
        this.base = base;
        this.onClick();
        this.subscribeHeartStatusData();
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.model.isLiked = !this.model.isLiked;
            this.setIcon();
            this.base.chartService.requestSetHeartLikedStatus();
        });
    }

    private subscribeHeartStatusData() {
        this.base.chartService.subscribeHeartStatusData((model: HeartStatusDataModel) => {
            this.model = model;
            this.setIcon();
        });
    }

    private setIcon() {
        this.element.setAttribute('title', this.model.tooltip);
        if (this.model.isLiked) {
            this.element.addClass('selected');
        } else {
            this.element.removeClass('selected');
        }
    }
}